import { DefaultHttpClient } from "../../core/api/HttpClient.js";

export type PermissionMode = "server" | "channel" | "member";

export type PermissionSource = {
    type            : "role" | "member" | "administrator";
    id              : string;
    name            : string;
    color?          : number;
    position?       : number;
    viaPermission?  : string;
    effective?      : boolean;
};

export type SimulatedPermission = {
    key        : string;
    bit        : string;
    allowed    : boolean;
    allowedBy  : PermissionSource[];
    deniedBy   : PermissionSource[];
};

export type SimulatedAction = {
    key      : string;
    allowed  : boolean;
    reasons  : string[];
    required : string[];
};

export type SimulationMember = {
    id          : string;
    displayName : string;
    username    : string;
    avatar      : string | null;
    highestRole : {
        id       : string;
        name     : string;
        position : number;
    };
};

export type SimulationChannel = {
    id       : string;
    name     : string;
    type     : number;
    position : number;
    parentId : string | null;
};

export type PermissionSimulationResponse =
    | {
        mode        : "server";
        user        : SimulationMember;
        permissions : SimulatedPermission[];
    }
    | {
        mode        : "channel";
        user        : SimulationMember;
        channel     : SimulationChannel;
        permissions : SimulatedPermission[];
    }
    | {
        mode    : "member";
        user    : SimulationMember;
        target  : SimulationMember;
        channel : SimulationChannel | null;
        actions : SimulatedAction[];
    };

export type SimulatePermissionsInput = {
    mode          : PermissionMode;
    userId        : string;
    channelId?    : string;
    targetUserId? : string;
    signal?       : AbortSignal;
};

export function simulateDiscordPermissions(input: SimulatePermissionsInput) {
    const params = new URLSearchParams({
        mode   : input.mode,
        userId : input.userId,
    });

    if (input.channelId)
        params.set("channelId", input.channelId);

    if (input.targetUserId)
        params.set("targetUserId", input.targetUserId);

    return DefaultHttpClient.json<PermissionSimulationResponse>(
        `/api/discord-permissions/simulate?${params.toString()}`,
        { signal: input.signal },
    );
}
